"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInfoBanner = exports.sortBanner = exports.selectPageList = exports.savePageList = exports.removeBanner = exports.getSwiperList = exports.editBanner = exports.deleteBanner = exports.bannerList = exports.addBanner = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 获取轮播图列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var bannerList = exports.bannerList = function bannerList(data) {
  return _api.default.request({
    url: '/banner/bannerList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 轮播图排序
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var sortBanner = exports.sortBanner = function sortBanner(data) {
  return _api.default.request({
    url: '/banner/bannerSort',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除轮播图
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var removeBanner = exports.removeBanner = function removeBanner(data) {
  return _api.default.request({
    url: '/banner/removeBanner',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增轮播图
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var addBanner = exports.addBanner = function addBanner(data) {
  return _api.default.request({
    url: '/banner/saveBanner',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑轮播图
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var editBanner = exports.editBanner = function editBanner(data) {
  return _api.default.request({
    url: '/banner/editBanner',
    method: 'post',
    data: data
  });
};
/**
 * 描述 通过省份code获取轮播图
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var getSwiperList = exports.getSwiperList = function getSwiperList(data) {
  return _api.default.request({
    url: '/web/getBannerByCode',
    method: 'post',
    data: data
  });
};

//学校院校版
//banner/school/selectPageList
var selectPageList = exports.selectPageList = function selectPageList(data) {
  return _api.default.request({
    url: '/banner/school/selectPageList',
    method: 'post',
    data: data
  });
};

///banner/school/save校版保存
var savePageList = exports.savePageList = function savePageList(data) {
  return _api.default.request({
    url: '/banner/school/save',
    method: 'post',
    data: data
  });
};

///banner/school/updateInfo //修改
var updateInfoBanner = exports.updateInfoBanner = function updateInfoBanner(data) {
  return _api.default.request({
    url: '/banner/school/updateInfo',
    method: 'post',
    data: data
  });
};
var deleteBanner = exports.deleteBanner = function deleteBanner(data) {
  return _api.default.request({
    url: '/banner/school/delete',
    method: 'post',
    data: data
  });
};